import React from 'react'
export interface MoreFilterContextProps {
    selectedItems?: Record<string, string[]> | undefined
    /** Called when the user changes their filter selection (e.g., by selecting an item in a filter,
     * unselecting an item, clearing a filter, or clearing all filters). */
    onFilterSelectionChange?: (
        selection: Record<string, string[]> | undefined
    ) => void
    setSelection?: (selection: Record<string, string[]> | undefined) => void
    handleEmptyInputSelection?: (
        selection: Record<string, Date | string | null> | undefined
    ) => void
    emptyInputSelection?: Record<string, Date | string | null> | undefined
}

export const MoreFilterContext = React.createContext<MoreFilterContextProps>({})
